module.exports = __webpack_public_path__ + "static/media/thatsit-img.fdfe3e2e.png";